export default {
    getCompanyName
};
    
// Returns company name based on users email
function getCompanyName(session) {
    if (emailNotValid(session)) return null;
    // TODO: start capturing company name during account creation
    const blacklist = [
        "aol", "att.net", "comcast.net", "facebook", "gmail", "gmx.com", "googlemail", "google.com", "hotmail",
        "mac.com", "me.com", "mail.com", "msn.com", "live.com", "sbcglobal", "verizon", "yahoo",
    ];
    const companyName = session.email.split('@')[1];
    if (!companyName || blacklist.some(el => companyName.includes(el))) return null;

    return companyName;
}

function emailNotValid(session) {
    return !session.email || !session.isCustomer || session.isCustomer && !session.email.includes('@')
}
